<template>
    <svg viewBox="0 0 20 20"><circle cx="9.5" cy="4.5" r="1.5"></circle><circle cx="9.5" cy="10.5" r="1.5"></circle><circle cx="9.5" cy="16.5" r="1.5"></circle></svg>
</template>
<script>
export default {
    name: 'icon-more3v',
};
</script>
<style>

</style>
